module.exports = __webpack_public_path__ + "img/1494476971.f5a2715b.jpg";